import "@styles/styles-AuthLoading.css";

export const AuthLoading = () => {
  return (
    <div className="auth-loading-wrapper">
      Loading...
      <iframe
        className="auth-loading-iframe"
        src="/whistle-loader.html"
        title="Loading"
        aria-label="Loading"
      />
    </div>
  );
};
